import React from "react";
import PropTypes from "prop-types";
import { Button, Col, Label, Row } from "reactstrap";
import { Icon } from "@mc/mc-legacy";
import classNames from "classnames";
import "./SignRequestTitle.scss";
/**
 * Nappis položky requestu
 */

class SignRequestTitle extends React.Component {
  static propTypes = {
    signRequest: PropTypes.object,
    icon: PropTypes.object,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    customRender: PropTypes.func,
  };

  render() {
    const { signRequest, icon, onClick, disabled, customRender } = this.props;
    const cls = ["title-label"];

    if (onClick && !disabled) {
      cls.push("link");
    }

    return (
      <div className={"sign-request-title-wrapper"}>
        {icon && <Icon icon={"file-pdf-o"} className={"title-icon"} />}
        <Label onClick={!disabled && onClick} className={classNames(cls)}>
          {signRequest.name}
        </Label>
        {customRender && customRender(signRequest)}
      </div>
    );
  }
}

export default SignRequestTitle;
